import { useMemo } from 'react';

import { usePeerToPeerModules } from '@bonusly/common-give-box';
import { useCurrentUser } from '@bonusly/who-am-i';

import { Bonus } from '../../../../../../types/bonus';
import { useContextualizedBonusDetails } from '../../../hooks/use-contextualized-bonus-details';

export const useCommentModules = (bonus: Bonus) => {
	const { canUserAddOn, isCreatedByUser } = useContextualizedBonusDetails(bonus);
	const user = useCurrentUser();
	const canUserAddAmount = user.can_give_non_zero && canUserAddOn;

	const baseModules = usePeerToPeerModules({
		includeEmoji: true,
		includeHashtag: true,
		includeLink: true,
		includeMention: true,
		includeAmount: canUserAddAmount,
		includeGif: true,
		includeAttachment: true,
		includeVideoRecording: true,
		includeAudioRecording: true,
		includePrivacy: false,
		includeRecipient: false,
		includeSuggestionHighlight: true,
	});

	return useMemo(() => {
		const modules = [...baseModules];

		// Include giver module if the bonus giver can receive and the user is not the creator
		if (!isCreatedByUser && bonus.giver.can_receive) {
			modules.push('include-giver');
		}

		return modules;
	}, [baseModules, isCreatedByUser, bonus.giver.can_receive]);
};
